var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25055_2963)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.39405,
    cy: 8.00004,
    r: 5.77778,
    stroke: "#E7E8E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51655 11.9859L7.74394 12.0901C8.04459 12.2277 8.2345 12.5091 8.2345 12.8169C8.2345 13.2657 8.7928 13.7778 9.28292 13.7778C10.5831 13.7778 10.6278 13.4345 11.2232 13.0495C11.4036 12.9328 11.5826 12.8114 11.7346 12.6595L12.8385 11.5556C13.194 11.2 12.1122 11.0369 11.5269 10.9998C10.9605 10.9998 10.3883 10.6329 10.3883 10.0137V9.68499C10.3883 8.95883 9.74548 8.37015 8.95245 8.37015H6.79861C6.40209 8.37015 6.08066 8.07582 6.08066 7.71274C6.08066 7.34965 6.40209 7.05532 6.79861 7.05532H7.33234C7.83059 7.05532 8.2345 6.68546 8.2345 6.22922V6.12253C8.2345 5.61116 8.78162 5.25006 9.31143 5.41178C9.84123 5.57349 10.3883 5.21239 10.3883 4.70102V4.50076C10.3883 4.1469 9.94019 3.17266 9.52697 2.80518C9.38603 2.67984 9.19729 2.62372 9.02858 2.53938L8.64837 2.3493C8.47966 2.26496 8.30004 2.20057 8.11145 2.19726C7.38776 2.18455 6.19679 2.46338 5.58541 2.73847C5.48057 2.78564 5.38591 2.85081 5.29614 2.92263L4.0845 3.89193C3.99472 3.96375 3.89553 4.02368 3.80708 4.09712C3.27619 4.5379 3.20886 5.56975 3.20886 6.22206C3.20886 6.75559 3.44032 7.26726 3.85232 7.64452L6.39118 9.96933C6.65205 10.2082 6.79861 10.5322 6.79861 10.87V10.9222C6.79861 11.3727 7.07655 11.7845 7.51655 11.9859Z",
    fill: "#E7E8E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25055_2963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.394043)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarth);
export default __webpack_public_path__ + "static/media/earth.ae88103577162623416ccb875e1e463b.svg";
export { ForwardRef as ReactComponent };